var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"packages"},[_c('v-row',_vm._l((_vm.packages),function(item,i){return _c('v-col',{key:i,attrs:{"cols":"12","md":"6"}},[_c('CompanyPlan',{attrs:{"plan":item,"color":_vm.packagesBranding[i]}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }